import { Injectable } from '@angular/core';
import { WindowService } from '@app/core/services/window.service';
import * as R from 'ramda';

@Injectable()
export class DeviceService {

  private readonly macPlatforms = ['macOS', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];

  constructor(private readonly windowService: WindowService) {
  }

  getOS() {
    const navigator = this.windowService.navigator;
    return R.path(['userAgentData', 'platform'], navigator) ?? R.prop('platform', navigator);
  }

  isMacOS() {
    return R.includes(this.getOS(), this.macPlatforms);
  }
}
